import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";


export default function LabServices() {
  const [labServicesData, setLabServicesData] = useState([]);
  const [allLabTests, setAllLabTests] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [viewLinkedTests, setViewLinkedTests] = useState([]);
  const [editItem, setEditItem] = useState(null);

  const [formData, setFormData] = useState({ category: "", serviceName: "", price: "" });
  const [selectedTestIds, setSelectedTestIds] = useState([]);
  const [testSearch, setTestSearch] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const navigate = useNavigate();

  useEffect(() => {
    getLabServices();
    getAllLabTests();
  }, []);

  const getLabServices = async () => {
    try {
      const res = await axiosInstance.get(`getAllLabServices`);
      setLabServicesData(res.data.data || []);
    } catch (error) {
      console.error("Error fetching lab services:", error);
      Swal.fire("Error", "Failed to load lab services", "error");
    }
  };

  const getAllLabTests = async () => {
    try {
      const res = await axiosInstance.get(`getAllLabTests`);
      setAllLabTests(res.data.data || []);
    } catch (error) {
      console.error("Error fetching lab tests:", error);
    }
  };

  const fetchLinkedTests = async (serviceId) => {
    try {
      const res = await axiosInstance.get(`getLabServiceTests/${serviceId}`);
      return res.data.data || [];
    } catch (error) {
      console.error("Error fetching linked tests:", error);
      return [];
    }
  };

  const handleEdit = async (item) => {
    const serviceName = item.serviceName || item.service || item.service_name || item.name || "";
    setFormData({ category: item.category || "", serviceName, price: item.price || "" });
    setEditItem(item);
    const linked = await fetchLinkedTests(item.id);
    setSelectedTestIds(linked.map((t) => t.id));
    setTestSearch("");
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This lab service will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (confirm.isConfirmed) {
      try {
        await axiosInstance.delete(`deleteLabService/${id}`);
        Swal.fire("Deleted!", "Lab service has been deleted.", "success");
        getLabServices();
      } catch (error) {
        console.error("Delete failed", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  const handleAddEdit = async (e) => {
    e.preventDefault();
    try {
      let serviceId;
      if (editItem?.id) {
        await axiosInstance.put(`editLabServices/${editItem.id}`, formData);
        serviceId = editItem.id;
        Swal.fire("Success", "Lab service updated successfully", "success");
      } else {
        const res = await axiosInstance.post(`addLabService`, formData);
        serviceId = res.data.data?.serviceId;
        Swal.fire("Success", "Lab service added successfully", "success");
      }

      // Save linked lab tests
      await axiosInstance.post(`setLabServiceTests`, {
        lab_service_id: serviceId,
        lab_test_ids: selectedTestIds,
      });

      resetForm();
      getLabServices();
    } catch (error) {
      console.error("Submit failed", error);
      const msg = error?.response?.data?.message || "Something went wrong!";
      Swal.fire("Error", msg, "error");
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleTestSelection = (id) => {
    setSelectedTestIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const resetForm = () => {
    setFormData({ category: "", serviceName: "", price: "" });
    setEditItem(null);
    setSelectedTestIds([]);
    setTestSearch("");
    setModalOpen(false);
  };

  const openViewModal = async (item) => {
    setViewItem(item);
    setViewLinkedTests([]);
    setViewModalOpen(true);
    const linked = await fetchLinkedTests(item.id);
    setViewLinkedTests(linked);
  };

  const filteredLabServices = labServicesData.filter((service) => {
    const serviceName = service.serviceName || service.service || service.service_name || service.name;
    return (
      (serviceName && serviceName.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (service.category && service.category.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  });

  const totalPages = Math.ceil(filteredLabServices.length / itemsPerPage);
  const paginatedLabServices = filteredLabServices.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const filteredTests = allLabTests.filter((t) =>
    t.test_name?.toLowerCase().includes(testSearch.toLowerCase())
  );

  const Pagination = ({ currentPage, totalPages, setCurrentPage }) => (
    <div className="d-flex align-items-center gap-3">
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
      >
        &lt;&lt;
      </button>
      <span>{currentPage} / {totalPages}</span>
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
      >
        &gt;&gt;
      </button>
    </div>
  );

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="col-12">
                <div className="arrowHead">
                  <button className="backArrow" onClick={() => navigate(-1)} title="Back">
                    <i className="fa fa-arrow-left"></i>
                  </button>
                  <h5 className="mb-0">Lab Services List</h5>
                </div>
              </div>

              <div className="table-card patientCardHeader" style={{ marginTop: "25px" }}>
                <div className="tableHeader">
                  <div className="d-flex justify-content-between align-items-center">
                    <div style={{ width: "300px", position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Search by category or service..."
                        value={searchQuery}
                        onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                        className="form-control"
                        style={{ paddingLeft: "35px", marginBottom: "unset" }}
                      />
                      <span style={{ position: "absolute", top: "50%", left: "10px", transform: "translateY(-50%)", pointerEvents: "none", color: "#888" }}>
                        <i className="ti ti-search f-16"></i>
                      </span>
                    </div>
                    <button className="bgBtn" onClick={() => { setEditItem(null); setSelectedTestIds([]); setTestSearch(""); setModalOpen(true); }}>
                      Add Lab Service
                    </button>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr className="text-center">
                        <th>Sr No.</th>
                        <th>Category</th>
                        <th>Service</th>
                        <th>Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedLabServices.length > 0 ? (
                        paginatedLabServices.map((item, index) => (
                          <tr key={item.id} className="text-center">
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{item.category}</td>
                            <td>{item.serviceName || item.service || item.service_name || item.name || 'N/A'}</td>
                            <td>{item.price ? `${item.price} BHD` : 'N/A'}</td>
                            <td>
                              <div onClick={() => openViewModal(item)} style={{ cursor: "pointer" }} className="avtar avtar-xs btn-link-secondary viewIcon">
                                <i className="ti ti-eye f-20" /><span>View</span>
                              </div>
                              <div onClick={() => handleEdit(item)} style={{ cursor: "pointer" }} className="avtar avtar-xs btn-link-secondary editIcon">
                                <i className="ti ti-edit f-20" /><span>Edit</span>
                              </div>
                              <div onClick={() => handleDelete(item.id)} style={{ cursor: "pointer" }} className="avtar avtar-xs btn-link-secondary deleteIcon">
                                <i className="ti ti-trash f-20" /><span>Delete</span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center">No lab services found.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {totalPages > 1 && (
                  <div className="d-flex justify-content-end mt-3">
                    <Pagination currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add / Edit Modal */}
      {modalOpen && (
        <div className="modal fade show" style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editItem ? "Edit Lab Service" : "Add Lab Service"}</h5>
              </div>
              <form onSubmit={handleAddEdit}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Category</label>
                      <input
                        type="text"
                        className="form-control"
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                        placeholder="Enter category"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Service</label>
                      <input
                        type="text"
                        className="form-control"
                        name="serviceName"
                        value={formData.serviceName}
                        onChange={handleInputChange}
                        placeholder="Enter service"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Price</label>
                      <input
                        type="number"
                        className="form-control"
                        name="price"
                        value={formData.price}
                        onChange={handleInputChange}
                        placeholder="Enter price"
                        min="0"
                        step="0.01"
                      />
                    </div>

                    {/* Lab Tests Selector */}
                    <div className="col-12">
                      <label className="form-label">
                        Linked Lab Tests
                        {selectedTestIds.length > 0 && (
                          <span style={{ marginLeft: "8px", background: "#4680ff", color: "#fff", borderRadius: "10px", padding: "1px 8px", fontSize: "11px", fontWeight: "600" }}>
                            {selectedTestIds.length} selected
                          </span>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Search lab tests..."
                        value={testSearch}
                        onChange={(e) => setTestSearch(e.target.value)}
                      />
                      <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "6px", padding: "8px" }}>
                        {filteredTests.length === 0 ? (
                          <div style={{ color: "#9aa0ac", fontSize: "13px", textAlign: "center", padding: "12px 0" }}>
                            No lab tests found.
                          </div>
                        ) : (
                          filteredTests.map((test) => (
                            <div
                              key={test.id}
                              onClick={() => toggleTestSelection(test.id)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "6px 8px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                background: selectedTestIds.includes(test.id) ? "#eef2ff" : "transparent",
                                marginBottom: "2px",
                              }}
                            >
                              <input
                                type="checkbox"
                                readOnly
                                checked={selectedTestIds.includes(test.id)}
                                style={{ cursor: "pointer" }}
                              />
                              <span style={{ fontSize: "13px", flex: 1 }}>{test.test_name}</span>
                              {test.units && (
                                <span style={{ fontSize: "11px", color: "#9aa0ac" }}>{test.units}</span>
                              )}
                              {(test.min_range !== null && test.max_range !== null) && (
                                <span style={{ fontSize: "11px", color: "#6c757d" }}>
                                  {parseFloat(test.min_range).toFixed(2)} – {parseFloat(test.max_range).toFixed(2)}
                                </span>
                              )}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="cancelText" onClick={resetForm}>Cancel</button>
                  <button type="submit" className="bgBtn">{editItem ? "Update" : "Add"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {viewModalOpen && (
        <div className="modal fade show" style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Lab Service Details</h5>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Category</label>
                    <input type="text" className="form-control" value={viewItem?.category || ''} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Service Name</label>
                    <input type="text" className="form-control" value={viewItem?.serviceName || viewItem?.service || viewItem?.service_name || viewItem?.name || ''} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Price</label>
                    <input type="text" className="form-control" value={viewItem?.price || 'N/A'} readOnly />
                  </div>

                  {/* Linked Lab Tests */}
                  <div className="col-12">
                    <label className="form-label">Linked Lab Tests</label>
                    {viewLinkedTests.length === 0 ? (
                      <div style={{ color: "#9aa0ac", fontSize: "13px", padding: "10px 0" }}>No lab tests linked to this service.</div>
                    ) : (
                      <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", overflow: "hidden" }}>
                        <table className="table table-sm mb-0" style={{ fontSize: "13px" }}>
                          <thead style={{ background: "#f8f9fa" }}>
                            <tr>
                              <th>#</th>
                              <th>Test Name</th>
                              <th>Units</th>
                              <th>Min Range</th>
                              <th>Max Range</th>
                              <th>Methodology</th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewLinkedTests.map((t, i) => (
                              <tr key={t.id}>
                                <td>{i + 1}</td>
                                <td>{t.test_name}</td>
                                <td>{t.units || '—'}</td>
                                <td>{t.min_range !== null ? parseFloat(t.min_range).toFixed(2) : '—'}</td>
                                <td>{t.max_range !== null ? parseFloat(t.max_range).toFixed(2) : '—'}</td>
                                <td style={{ maxWidth: "160px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {t.methodology || '—'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="cancelText" onClick={() => setViewModalOpen(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
